module.exports = __webpack_public_path__ + "static/media/splotch.8eb45e54.svg";